export enum TabsetType {
  Line = 'line',
  Card = 'card',
  EditableCard = 'editable-card'
}
